// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"2":"patient","123":"case","391":"info","430":"doctor","594":"about","857":"report","962":"home","966":"login"}[chunkId] + "." + {"2":"bdbb90ee","123":"a7190f54","391":"5d9032c6","430":"5fee012f","594":"17c5bd1e","857":"62fc8de4","962":"552937e8","966":"575f3f19"}[chunkId] + ".js";
};